import axios, { AxiosResponse } from 'axios';
import { LocalHelper } from './LocalHelper';
import { saveAs } from 'file-saver';

export abstract class HttpHelper {
  public static IsRemoteHosted(): boolean {
    if (window.location.href.includes('cloudkwekerijbloemendaal')) {
      return true;
    } else {
      return false;
    }
  }

  public static GetUrlBaseApi(): string {
    if (this.IsRemoteHosted()) {
      return LocalHelper.GetUrlForApiRemote();
    } else {
      return LocalHelper.GetUrlForApiLocal();
    }
    return LocalHelper.GetUrlForApiLocalHost();
  }

  public static GetUrlBaseHome(): string {
    if (this.IsRemoteHosted()) {
      return LocalHelper.GetUrlForHomeWebAppRemote();
    } else {
      return LocalHelper.GetUrlForHomeWebAppLocal();
    }
    return LocalHelper.GetUrlForHomeWebAppLocal();
  }

  public static GetUrlBaseApiHome(): string {
    if (this.IsRemoteHosted()) {
      return LocalHelper.GetUrlForApiRemoteHome();
    } else {
      return LocalHelper.GetUrlForApiLocalHome();
    }
    return LocalHelper.GetUrlForApiLocalHostHome();
  }

  public static GetUrlBaseApiPlatform(): string {
    if (this.IsRemoteHosted()) {
      return LocalHelper.GetUrlForApiRemotePlatform();
    } else {
      return LocalHelper.GetUrlForApiLocalPlatform();
    }
    return LocalHelper.GetUrlForApiLocalHostPlatform();
  }

  public static GetUrlStorageBaseApi() {
    if (this.IsRemoteHosted()) {
      return LocalHelper.GetUrlForStorageRemote();
    } else {
      return LocalHelper.GetUrlForStorageLocal();
    }
    return LocalHelper.GetUrlForStorageLocalHost();
  }

  public static async PostRequestForApi<T>(
    url: string,
    item: any,
    token?: string,
  ): Promise<T> {
    const respon = axios({
      method: 'post',
      url: url,
      timeout: 4000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify(item),
    });

    return respon.then((response) => response.data).catch((error) => {});
  }

  public static async DeleteRequestForApi<T>(
    url: string,
    item: any,
    token: string,
  ): Promise<T> {
    const respon = axios({
      method: 'delete',
      url: url,
      timeout: 4000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify(item),
    });

    return respon
      .then((response) => response.data)
      .catch((error) => {
        return error.response;
      });
  }

  public static async GetRequestForApi<T>(
    url: string,
    token?: string,
  ): Promise<T>;
  public static async GetRequestForApi<T>(
    url: string,
    token?: string,
  ): Promise<Array<T>> {
    const respon = axios({
      method: 'get',
      url: url,
      timeout: 4000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    return respon.then((response) => response.data).catch((error) => {});
  }

  public static async UpdateRequestForApi<T>(
    url: string,
    device: any,
    token: string,
  ): Promise<T> {
    const respon = axios({
      method: 'put',
      url: url,
      timeout: 4000,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify(device),
    });
    return respon
      .then((response) => {
        response.data;
      })
      .catch((error) => {
        return error.response;
      });
  }

  public static async AuthorizedRequest<T>(url: string, data: any) {
    // let token = this.authService.getToken() |
    let token = '';
    const respon = axios({
      method: 'post',
      url: url,
      timeout: 4000,
      headers: {
        'Access-Control-Allow-Origin': true,
        'Content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify(data),
    });
    return respon.then((response) => response.data).catch((error) => {});
  }

  public static async PostRequestForApiForFile<T>(
    url: string,
    item: any,
    token?: string,
  ): Promise<T> {
    const respon = axios({
      method: 'post',
      url: url,
      timeout: 4000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
      data: JSON.stringify(item),
    });

    return respon
      .then((response) => {
      const blob = new Blob([response.data], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'people.json';
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url); // opruimen
        return response.data;
      })
      .catch((error) => {});
  }

}
